import { useContext } from "react";
import { LocationHandlerContext } from "./context";
import { LocationHandlerContextValue } from "./types";

/**
 * @hook useLocationHandlerContext
 *
 * Provides safe access to the LocationHandlerContext.
 * This hook guarantees that any consumer component is wrapped
 * inside <LocationHandlerProvider />, preventing undefined context usage.
 *
 * @returns {LocationHandlerContextValue} The context value containing
 *          state, actions, and helpers for managing Location entities.
 *
 * @throws {Error} If invoked outside of the LocationHandlerProvider.
 */
export const useLocationHandlerContext = (): LocationHandlerContextValue => {
  const context = useContext(LocationHandlerContext);

  if (!context) {
    throw new Error(
      "useLocationHandlerContext must be used within LocationHandlerProvider"
    );
  }

  return context;
};
